import { Component, OnInit, ViewChild, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl} from '@angular/forms';
import { Filters, FiltersStorage, TType } from '../../../../api/interfaces/user';
import { MobileDetectorService } from '../../../../services/mobileDetector/mobile-detector.service';
import {MatAccordion} from '@angular/material/expansion';
import { RegisterService } from 'src/app/api/services/register/register.service';
import { TrainingDays } from 'src/app/api/interfaces/register';


@Component({
  selector: 'app-filters-domiciliacion',
  templateUrl: './filters-domiciliacion.component.html',
  styleUrls: ['./filters-domiciliacion.component.scss']
})
export class FiltersDomiciliacionComponent implements OnInit {

  @ViewChild(MatAccordion) accordion: MatAccordion;
  @ViewChild('trainerSelect') trainerSelect;
  @Output() filtersChangeEvent = new EventEmitter<Filters>();

  isMobile: boolean = false;
  contador: number;
  filtersForm = new FormGroup({
    nombreApellido: new FormControl(),
    status: new FormControl(),
    type: new FormControl(),
    leido: new FormControl(),
    grupoId: new FormControl()
  });

  allStatus = [
    {
      name: "Exportado",
      est: "E"
    },
    {
      name: "No exportado",
      est: "N"
    },
  ];

  allTypes: TType[] = [];
  allTrainingDays: TrainingDays[] = [];
  
  disabled: boolean = true;
  statusClass = "inputsFilter";

  enabledTrainingDaysSelect: boolean = false;
  indexPresencial: number = -1;

  constructor(
    private mobileDetectorService: MobileDetectorService,
    private registerService: RegisterService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.isMobile = this.mobileDetectorService.isMobile();
    this.cdr.detectChanges();
    this.getTrainingTypes();
    this.getTrainingDays();
    this.filtersForm.statusChanges
    .subscribe(val => {
      const { nombreApellido, status, type,  leido, grupoId } = this.filtersForm.getRawValue();
      this.contador = 0;
      if(status) {
        this.contador++;
        this.statusClass = "inputsFilterWithContent"
      } else {
        this.statusClass = "inputsFilter"
      }
      if(type) {
        this.contador++;
      }
      if(nombreApellido) {
        this.contador++;
      }
      if(leido != null) {
        this.contador++;
      }
      if(grupoId) {
        this.contador++;
      }
      if(this.contador > 0) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    });
  }

  setFiltersFromLocalStorage() {
    // const filters: FiltersStorage = JSON.parse(localStorage.getItem('filters'));
    // if(filters) {
    //   this.filtersForm.patchValue({nombreApellido: filters.nombreApellido});
    //   this.filtersForm.patchValue({status: filters.status});
    //   this.filtersForm.patchValue({leido: filters.leido});
    //   this.filtersForm.patchValue({type: filters.type});
    // }
  }

  onSubmit() {
    this.filtersChangeEvent.emit(this.filtersForm.value);
  }

  clearAll() {
    this.filtersForm.patchValue({status: null});
    this.filtersForm.patchValue({type: null});
    this.filtersForm.patchValue({leido: null});
    this.filtersForm.patchValue({nombreApellido: null});
    this.filtersForm.patchValue({grupoId: null});
    this.filtersChangeEvent.emit(this.filtersForm.value);
    this.enabledTrainingDaysSelect = false;
  }

  clear(target: string) {
    switch (target) {
      case 'nombreApellido':
        this.filtersForm.patchValue({nombreApellido: null});
      break;
      
      
      case 'status':
        this.filtersForm.patchValue({status: null});
      break;
      
      case 'type':
        this.filtersForm.patchValue({type: null});
        this.filtersForm.patchValue({grupoId: null});
        this.enabledTrainingDaysSelect = false;
      break;

      case 'leido':
        this.filtersForm.patchValue({leido: null});
      break;

      case 'grupoId':
        this.filtersForm.patchValue({grupoId: null});
      break;
    }
    this.filtersChangeEvent.emit(this.filtersForm.value);
  }

  getTrainingTypes() {
    this.registerService.getTrainingTypes()
    .subscribe(response => {
      this.allTypes= response;
      //  guarda el id de online
      const index = this.allTypes.findIndex(element => element.entrenamientoTipoDescripcion == "Presencial");
      this.indexPresencial = this.allTypes[index].entrenamientoTipoId;

    },
      error => {
        console.error(error);
      });
  }

  getTrainingDays () {
    this.registerService.getTrainingDays()
    .subscribe(response => {
      this.allTrainingDays = response;
      //remover no definido y online
      this.allTrainingDays.splice(0,1);
      const index = this.allTrainingDays.findIndex(element => element.grupoDescripcion = "Online");
      this.allTrainingDays.splice(index,1);
    },
      error => {
        console.error(error);
      });
  }

  onChangeType() {
    const { type } = this.filtersForm.getRawValue();
    if(type) {
      this.enabledTrainingDaysSelect = (type == this.indexPresencial);
      if(!this.enabledTrainingDaysSelect) {
        this.filtersForm.patchValue({grupoId: null});
      }
    }
  }
}


